// ─────────────────────────────────────────────────────────────────
// Sehat AI — Specialty Data
// Symptom keywords → Medical specialty mapping
// ─────────────────────────────────────────────────────────────────

export const SYMPTOM_SPECIALTY_MAP = {
  // Cardiology
  heart: 'cardiologist', chest: 'cardiologist', cardiac: 'cardiologist',
  palpitation: 'cardiologist', 'dil dard': 'cardiologist', 'seena dard': 'cardiologist',
  'दिल': 'cardiologist', 'सीना': 'cardiologist',

  // Dermatology
  skin: 'dermatologist', rash: 'dermatologist', acne: 'dermatologist',
  eczema: 'dermatologist', allergy: 'dermatologist', itching: 'dermatologist',
  khujli: 'dermatologist', daane: 'dermatologist',
  'चर्म': 'dermatologist', 'खुजली': 'dermatologist', 'दाने': 'dermatologist',

  // Dentistry
  teeth: 'dentist', tooth: 'dentist', dental: 'dentist',
  gum: 'dentist', cavity: 'dentist',
  'dant dard': 'dentist', 'daant': 'dentist',
  'दांत': 'dentist', 'मसूड़े': 'dentist',

  // Ophthalmology
  eye: 'ophthalmologist', vision: 'ophthalmologist', sight: 'ophthalmologist',
  'ankh': 'ophthalmologist', 'aankh': 'ophthalmologist',
  'आंख': 'ophthalmologist', 'नज़र': 'ophthalmologist',

  // Orthopedics
  bone: 'orthopedic', joint: 'orthopedic', knee: 'orthopedic',
  back: 'orthopedic', spine: 'orthopedic', fracture: 'orthopedic',
  'haddi': 'orthopedic', 'kamar dard': 'orthopedic', 'ghutna': 'orthopedic',
  'पीठ': 'orthopedic', 'हड्डी': 'orthopedic', 'जोड़': 'orthopedic', 'घुटना': 'orthopedic',

  // Pediatrics
  child: 'pediatrician', baby: 'pediatrician', infant: 'pediatrician',
  kid: 'pediatrician', baccha: 'pediatrician', bachcha: 'pediatrician',
  'बच्चा': 'pediatrician', 'शिशु': 'pediatrician',

  // General Medicine
  fever: 'general physician', cold: 'general physician', flu: 'general physician',
  cough: 'general physician', headache: 'general physician', fatigue: 'general physician',
  weakness: 'general physician', vomiting: 'general physician',
  'sar dard': 'general physician', 'sir dard': 'general physician',
  'sardard': 'general physician', 'sirdard': 'general physician',
  'bukhaar': 'general physician', 'bukhar': 'general physician',
  'khansi': 'general physician', 'ulti': 'general physician', 'kamzori': 'general physician',
  'general physician': 'general physician',
  'बुखार': 'general physician', 'सर्दी': 'general physician',
  'खांसी': 'general physician', 'कमज़ोरी': 'general physician',

  // Gastroenterology
  stomach: 'gastroenterologist', digestion: 'gastroenterologist',
  gastric: 'gastroenterologist', acidity: 'gastroenterologist',
  diarrhea: 'gastroenterologist', constipation: 'gastroenterologist',
  'pet dard': 'gastroenterologist',
  'पेट': 'gastroenterologist', 'एसिडिटी': 'gastroenterologist',

  // Psychiatry
  mental: 'psychiatrist', anxiety: 'psychiatrist', depression: 'psychiatrist',
  stress: 'psychiatrist', insomnia: 'psychiatrist', panic: 'psychiatrist',
  'chinta': 'psychiatrist', 'neend nahi': 'psychiatrist', 'tension': 'psychiatrist',
  'मानसिक': 'psychiatrist', 'चिंता': 'psychiatrist', 'नींद': 'psychiatrist',

  // Neurology
  neuro: 'neurologist', brain: 'neurologist', migraine: 'neurologist',
  seizure: 'neurologist', 'neurologist': 'neurologist',
  'दिमाग': 'neurologist', 'सिरदर्द': 'neurologist', 'मिर्गी': 'neurologist',

  // Nephrology
  kidney: 'nephrologist', urine: 'nephrologist',
  'gurda': 'nephrologist', 'peshab': 'nephrologist',
  'गुर्दा': 'nephrologist', 'पेशाब': 'nephrologist',

  // Endocrinology
  diabetes: 'endocrinologist', thyroid: 'endocrinologist',
  'sugar': 'endocrinologist', 'madhumeh': 'endocrinologist',
  'मधुमेह': 'endocrinologist', 'थायराइड': 'endocrinologist',

  // Pulmonology
  lungs: 'pulmonologist', breathing: 'pulmonologist', asthma: 'pulmonologist',
  'sans': 'pulmonologist', 'saans': 'pulmonologist',
  'सांस': 'pulmonologist', 'फेफड़े': 'pulmonologist',

  // ENT
  ear: 'ENT specialist', nose: 'ENT specialist', throat: 'ENT specialist',
  'kaan': 'ENT specialist', 'naak': 'ENT specialist', 'gala': 'ENT specialist',
  'ent': 'ENT specialist',
  'कान': 'ENT specialist', 'नाक': 'ENT specialist', 'गला': 'ENT specialist',

  // Gynecology
  gynec: 'gynecologist', pregnancy: 'gynecologist',
  period: 'gynecologist', women: 'gynecologist',
  'mahwari': 'gynecologist', 'garbh': 'gynecologist',
  'gynecologist': 'gynecologist',
  'गर्भ': 'gynecologist', 'मासिक': 'gynecologist',
};

export const SPECIALTY_LABELS = {
  'cardiologist': 'Cardiologist',
  'dermatologist': 'Dermatologist',
  'dentist': 'Dentist',
  'ophthalmologist': 'Eye Specialist',
  'orthopedic': 'Orthopedist',
  'pediatrician': 'Pediatrician',
  'general physician': 'General Physician',
  'gastroenterologist': 'Gastroenterologist',
  'psychiatrist': 'Psychiatrist',
  'neurologist': 'Neurologist',
  'nephrologist': 'Nephrologist',
  'endocrinologist': 'Endocrinologist',
  'pulmonologist': 'Pulmonologist',
  'ENT specialist': 'ENT Specialist',
  'gynecologist': 'Gynecologist',
};

export const SPECIALTY_ICONS = {
  'cardiologist': '🫀',
  'dermatologist': '🧴',
  'dentist': '🦷',
  'ophthalmologist': '👁️',
  'orthopedic': '🦴',
  'pediatrician': '👶',
  'general physician': '🩺',
  'gastroenterologist': '🫁',
  'psychiatrist': '🧠',
  'neurologist': '🧬',
  'nephrologist': '🫘',
  'endocrinologist': '⚗️',
  'pulmonologist': '🫁',
  'ENT specialist': '👂',
  'gynecologist': '🌸',
};

export const QUICK_SYMPTOMS = [
  { label: 'बुखार / Fever',       icon: '🌡️', msg: 'I have high fever and body ache' },
  { label: 'Chest Pain',           icon: '🫀', msg: 'I have chest pain and shortness of breath' },
  { label: 'Skin Problem',         icon: '🧴', msg: 'I have skin rash and itching allergy' },
  { label: 'Dant Dard',            icon: '🦷', msg: 'मुझे बहुत दांत में दर्द है' },
  { label: 'Back / Joint Pain',    icon: '🦴', msg: 'I have severe back and joint pain' },
  { label: 'Bachche ki Takleef',   icon: '👶', msg: 'My child has fever and is not feeling well' },
  { label: 'Aankhon ki Takleef',   icon: '👁️', msg: 'I have eye pain and blurred vision' },
  { label: 'Mental Stress',        icon: '🧠', msg: 'I am feeling very anxious and depressed' },
];

export const SIDEBAR_SPECIALTIES = [
  'general physician', 'cardiologist', 'dermatologist', 'dentist',
  'orthopedic', 'pediatrician', 'gynecologist', 'psychiatrist',
  'neurologist', 'ENT specialist', 'ophthalmologist',
];

// Short ASCII keywords need word-boundary matching to prevent false substring hits.
// e.g. 'ent' must NOT match inside 'gastroenterologist', 'treatment', 'patient' etc.
const BOUNDARY_KEYWORDS = new Set(
  Object.keys(SYMPTOM_SPECIALTY_MAP).filter(k => k.length <= 6 && /^[a-zA-Z]+$/.test(k))
);

export function detectSpecialty(text) {
  const lower = text.toLowerCase();
  for (const [keyword, specialty] of Object.entries(SYMPTOM_SPECIALTY_MAP)) {
    if (BOUNDARY_KEYWORDS.has(keyword)) {
      // Word-boundary check: surrounded by non-letter characters
      const re = new RegExp(`(?<![a-z])${keyword}(?![a-z])`, 'i');
      if (re.test(lower)) return specialty;
    } else {
      if (lower.includes(keyword)) return specialty;
    }
  }
  return null;
}
